import React from 'react';

export function Footer() {
    return (
        <footer className="mt-5">
            <div className="container-fluid py-3 bg-dark">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="text-light">
                                <nas-footer className="ui-theme-white"
                                    data-lastupdate="2022-04-01" data-faqurl={process.env.REACT_APP_FQA_FOOTER_URL}>
                                </nas-footer>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}


